import { tap } from 'lodash/fp';
import * as types from './actionTypes';
import * as designBuilderApi from '../api/designBuilder';
import Item from '../models/Item';
import Container from '../models/Container';
import estimateLoaded from './estimateLoaded';
import { itemTypes, itemSources, containerTypes } from '../helpers/globalVariables';
import loading from './loading';
import loaded from './loaded';
import globalError from './globalError';
import uniqueNewName from '../helpers/uniqueNewName';
import smoothScroll from '../helpers/smoothScroll';
import getElementHeight from '../helpers/getElementHeight';
import getContainerLabel from '../helpers/getContainerLabel';

function createContainerPayload(designId, containerName, label) {
  const container = new Container(containerName);
  container.designId = designId;
  container.charLabel = label;

  const item = new Item();
  container.addItem(item);

  return {
    designId,
    container,
    item,
  };
}

export default designId => (dispatch, getState) => {
  dispatch(loading());
  const { uiState, entities } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;
  const { containers, estimates } = entities;
  const { allIds, byId } = containers;

  const containersForEstimate = estimates.byId[selectedEstimate].containers;
  const existingNames = allIds.filter(id => containersForEstimate.indexOf(id) > -1)
    .map(givenId => byId[givenId].name);
  const theContainerName = uniqueNewName('Room {{num}}', existingNames);
  const containerLabel = getContainerLabel(containersForEstimate.length);
  const payload = createContainerPayload(designId, theContainerName, containerLabel);


  const apiRequest = {
    design: {
      designId: payload.container.designId,
    },
    containers: [
      {
        containerId: payload.container.containerId,
        name: payload.container.name,
        charLabel: payload.container.charLabel,
        containerType: containerTypes.room,
      },
    ],
    items: [
      {
        itemId: payload.item.itemId,
        label: payload.item.label,
        designId: payload.item.designId,
        containerId: payload.item.containerId,
        itemType: itemTypes.window,
        itemSource: itemSources.autobahn,
      },
    ],
  };

  designBuilderApi
    .saveContainer(apiRequest)
    .then((response) => {
      dispatch({ type: types.ADD_CONTAINER, payload });
      dispatch(estimateLoaded(response.data));
      smoothScroll(`#scrollbottom-${payload.container.containerId}`, getElementHeight('.itemCard'));
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
